// extracted by mini-css-extract-plugin
module.exports = {"truncateText":"AssetName_truncateText__M17Aw"};